import React from 'react'

import { Form, Col } from '_zari/core'

import EstadoTransferenciasConstant from 'constants/estadosTransferencias'

const EstadoFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='ESTADO' htmlFor='select-estado' md={4} />
      <Col md={8}>
        <Form.Select 
        name="selectEstado"
        value={value} onChange={onChange} id='select-estado'>
          {EstadoTransferenciasConstant.__arrayRecepcion.map((val, key) => (
            <option key={key} value={val.id}>
              {val.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(EstadoFormGroup)
